import { useCallback, useState } from "react";
import _ from "lodash";
import { Autocomplete, AutocompleteItem } from "@nextui-org/react";
import { useCourses } from "../../courses/hooks/useCourses";

function CourseSelection({ grade, setCourseId }) {
    const [searchValue, setSearchValue] = useState("");

    const { courses, isPending } = useCourses({
        filter: { field: "grade", value: grade },
        perPage: 25,
        searchValue,
    });

    const handleChange = (value) => {
        setCourseId(value);
    };

    const onSearchChange = useCallback(
        _.debounce((value) => {
            if (value.trim() || value === "") {
                setSearchValue(value);
            }
        }, 500),
        [setSearchValue]
    );

    return (
        <div className="w-4/5 pt-5 lg:w-2/5">
            <p className="py-3 text-lg font-medium text-primary-color-primary">
                الكورس :
            </p>
            <Autocomplete
                size="lg"
                placeholder="بحث"
                className="w-full"
                aria-label="أختيار اسم الكورس"
                labelPlacement="outside"
                variant="underlined"
                isLoading={isPending}
                search={true}
                onSelectionChange={handleChange}
                onValueChange={(value) => {
                    onSearchChange(value);
                }}
            >
                {courses?.data.map((item) => (
                    <AutocompleteItem key={item.id} className="w-full py-3">
                        {item.attributes.name}
                    </AutocompleteItem>
                ))}
            </Autocomplete>
        </div>
    );
}

export default CourseSelection;
